import React from 'react'

const CashFlowNotes = () => {
  return <div>CashFlowNotes</div>
}

export default CashFlowNotes
